module.exports = __webpack_public_path__ + "images/emoji/open_book.d657f1ce7e240aeb3a11.png";